import bgimgMultiurl from "../../../assests/solutionImages/ImageGallery/BgimgTheme.svg";


function ImageGalleryTheme({ card }) {
  // console.log(card);

  const handleButtonClick = () => {
    if (card?.data?.buttonLink && card?.data?.buttonLink !== "#") {
      window.open(card?.data?.buttonLink, "_blank");
    }
  };

  return (
    <div className="flex p-2 md:py-4 justify-center bg-gray-200 ">
      <div className="relative max-w-[393px] bg-black rounded-xl shadow-lg overflow-hidden font-poppins">

        {/* Background Image with Title Overlay */}
        {card?.data?.showBackgroundImage && (
          <div className="relative w-full h-64 overflow-hidden">
            {/* Image */}
            <img
              src={card?.backgroundImage ? card?.backgroundImage : bgimgMultiurl}
              alt="Background"
              className="w-full h-full object-cover"
            />

            {/* Dark Overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-40"></div>

            {/* Title centered inside background */}
            <div className="absolute inset-0 flex items-center justify-center px-4">
              <h2 className="text-3xl font-bold text-white text-center break-words max-h-full overflow-auto shadow-lg">
                {card?.data?.title}
              </h2>
            </div>
          </div>
        )}

        {/* Title when NO background image */}
        {!card?.data?.showBackgroundImage && (
          <div className="pt-6 pb-4 text-center px-4">
            <h2 className="text-3xl font-bold text-white break-words">
              {card?.data?.title}
            </h2>
          </div>
        )}

        {/* Content Area */}
        <div className="bg-[#82066E] px-4 py-6">
          {/* Description */}
          <div className="mb-6">
            <p className="text-[#D0D0D0] text-center break-words leading-relaxed">
              {card?.data?.description}
            </p>
          </div>

          {/* Button */}
          <div className="flex justify-center items-center mb-6">
            <button
              className="btn btn-active border-none px-6 py-3 rounded-xl bg-white text-[#82066E] font-semibold hover:bg-gray-100 transition-colors break-words"
              onClick={handleButtonClick}
            >
              {card?.data?.buttonLabel}
            </button>
          </div>

          {/* Gallery Images */}
          {card?.data?.galleryImages?.length > 0 && (
            <div className="grid grid-cols-1 gap-4">
              {card?.data?.galleryImages?.map((image, index) => (
                <div key={index} className="rounded-lg overflow-hidden">
                  <img
                    src={image}
                    alt={`Gallery ${index + 1}`}
                    className="w-full h-auto object-cover"
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

    </div>
  );
}

export default ImageGalleryTheme;
